export { default as DotsVerticalSolidIcon } from './DotsVerticalSolidIcon';
